import getSeatUpperParent from '%paysera_seat_selection/js/seatSelection/services/getSeatUpperParent';
import compileUniqueSeatParents from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/seat/compileUniqueSeatParents';
import {
    OBJECT_TYPE_SEAT,
    SEAT_PURCHASE_STATUS_FREE,
    OBJECT_TYPE_GENERAL_ADMISSION,
    GENERAL_ADMISSION_PURCHASE_STATUS_FREE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import compileGeneralAdmission from '%paysera_seat_selection/js/seatSelection/redux/component/orm/reducers/compilers/compileGeneralAdmission';

export default ({ Seat, TicketType, GeneralAdmission }, { payload }) => {
    const { seating, ticketType } = payload;
    const parents = [];

    let loadedModel = null;
    if (seating.objectType === OBJECT_TYPE_SEAT) {
        loadedModel = Seat.get({ hash: seating.hash });
        loadedModel.purchaseStatus = SEAT_PURCHASE_STATUS_FREE;
        parents.push(getSeatUpperParent(loadedModel));
    }

    if (seating.objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
        loadedModel = GeneralAdmission.get({ hash: seating.hash });
        loadedModel.purchaseStatus = GENERAL_ADMISSION_PURCHASE_STATUS_FREE;
    }

    if (loadedModel !== null) {
        let existingTicketType = TicketType.get({ hash: ticketType.hash });
        if (!existingTicketType) {
            existingTicketType = TicketType.create({ ...ticketType });
        }
        loadedModel.compiled.fill = loadedModel.reservation.color;

        if (loadedModel.objectType === OBJECT_TYPE_SEAT) {
            loadedModel.reservation.seats.remove(loadedModel);
            existingTicketType.seats.add(loadedModel);
            loadedModel.reservation = null;
            loadedModel.ticketType = existingTicketType;

            compileUniqueSeatParents(parents, {});
        }

        if (loadedModel.objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
            loadedModel.reservation.generalAdmissions.remove(loadedModel);
            existingTicketType.generalAdmissions.add(loadedModel);
            loadedModel.reservation = null;
            loadedModel.ticketType = existingTicketType;

            compileGeneralAdmission(loadedModel);
        }
    }
};
